// UT30 is an unique code to identify each widget in the BPPR ecosystem
export const UT30SPSS = '30AYO';

//Videos IDs
export const videoId_welcome = '1_o7mg6rqt';
export const videoId_background = '1_zswhx4zs';
//export const videoId_
//images used in step 2
export const img_col1 = 'images/professional--marketplace.svg';
export const img_col2 = 'images/price.svg';
export const img_result = 'images/support.svg';

export const wx_ai_trial =
  'https://eu-de.dataplatform.cloud.ibm.com/registration/stepone?context=wx&preselect_region=true';
